import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "cal-activitati-container" }
const _hoisted_2 = { class: "d-flex align-center" }
const _hoisted_3 = { class: "header-icon-ring mr-3" }
const _hoisted_4 = { class: "integrated-toggle glass-pill" }
const _hoisted_5 = { class: "popup-header popup-header--activity" }
const _hoisted_6 = { class: "popup-header-main" }
const _hoisted_7 = { class: "popup-header-texts" }
const _hoisted_8 = { class: "popup-header-title" }
const _hoisted_9 = {
  key: 0,
  class: "details-container"
}
const _hoisted_10 = { class: "stats-grid-details" }
const _hoisted_11 = { class: "stat-card stat-card--date" }
const _hoisted_12 = { class: "stat-content" }
const _hoisted_13 = { class: "stat-value" }
const _hoisted_14 = { class: "info-sections-grid" }
const _hoisted_15 = { class: "info-column" }
const _hoisted_16 = { class: "info-section-card" }
const _hoisted_17 = { class: "info-list" }
const _hoisted_18 = { class: "info-item" }
const _hoisted_19 = { class: "value" }
const _hoisted_20 = { class: "info-item" }
const _hoisted_21 = { class: "value" }
const _hoisted_22 = { class: "info-column" }
const _hoisted_23 = { class: "info-section-card" }
const _hoisted_24 = { class: "info-list" }
const _hoisted_25 = { class: "info-item" }
const _hoisted_26 = { class: "value multiline" }
const _hoisted_27 = { class: "popup-body-simple popup-body-modern" }
const _hoisted_28 = { class: "form-content form-content-modern" }
const _hoisted_29 = { class: "form-footer footer-fixed footer-modern" }
const _hoisted_30 = { class: "footer-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxScheduler = _resolveComponent("DxScheduler")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_DxScrollView = _resolveComponent("DxScrollView")!
  const _component_DxPopup = _resolveComponent("DxPopup")!
  const _component_DxRequiredRule = _resolveComponent("DxRequiredRule")!
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxScrolling = _resolveComponent("DxScrolling")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxDropDownBox = _resolveComponent("DxDropDownBox")!
  const _component_DxFormItem = _resolveComponent("DxFormItem")!
  const _component_DxForm = _resolveComponent("DxForm")!
  const _component_DxButton = _resolveComponent("DxButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, {
      class: "cal-card glass-card flex-grow-1",
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_title, { class: "cal-card-header d-flex align-center px-6 py-4" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_v_icon, {
                  color: _ctx.APP_Color,
                  size: "20"
                }, {
                  default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                    _createTextVNode("mdi-calendar-account", -1)
                  ]))]),
                  _: 1
                }, 8, ["color"])
              ]),
              _cache[9] || (_cache[9] = _createElementVNode("span", { class: "font-weight-bold" }, "Program Activități", -1))
            ]),
            _createVNode(_component_v_spacer),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_v_switch, {
                modelValue: _ctx.doarAleMele,
                "onUpdate:modelValue": [
                  _cache[0] || (_cache[0] = ($event: any) => ((_ctx.doarAleMele) = $event)),
                  _ctx.onFilterChange
                ],
                label: "Doar ale mele",
                color: _ctx.APP_Color,
                "hide-details": "",
                density: "compact",
                class: "small-switch"
              }, null, 8, ["modelValue", "color", "onUpdate:modelValue"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_text, { class: "pa-0 scheduler-wrapper" }, {
          default: _withCtx(() => [
            _createVNode(_component_DxScheduler, {
              ref: "schedulerRef",
              "time-zone": "Europe/Bucharest",
              "data-source": _ctx.dataSource,
              height: "100%",
              views: _ctx.views,
              "current-view": "month",
              "current-date": _ctx.currentDate,
              "date-serialization-format": "yyyy-MM-ddTHH:mm:ssZ",
              "start-date-expr": "Data",
              "end-date-expr": "EndData",
              "text-expr": "Subject",
              "start-day-hour": 8,
              "end-day-hour": 20,
              "show-appointment-tooltip": false,
              editing: _ctx.editingConfig,
              onAppointmentClick: _ctx.onAppointmentClick,
              onAppointmentFormOpening: _ctx.onAppointmentFormOpening
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxLoadPanel, { enabled: true })
              ]),
              _: 1
            }, 8, ["data-source", "views", "current-date", "editing", "onAppointmentClick", "onAppointmentFormOpening"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_DxPopup, {
      visible: _ctx.detailsVisible,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.detailsVisible) = $event)),
      "drag-enabled": false,
      "hide-on-outside-click": true,
      "show-close-button": true,
      width: 750,
      height: "450",
      class: "premium-popup"
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[10] || (_cache[10] = _createElementVNode("span", { class: "popup-header-icon dx-icon-task" }, null, -1)),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.selectedActivity?.TipActivitate?.Nume || 'Activitate CRM'), 1)
            ])
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_DxScrollView, {
          width: "100%",
          height: "auto",
          class: "details-scroll-view"
        }, {
          default: _withCtx(() => [
            (_ctx.selectedActivity)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "stat-icon dx-icon-event" }, null, -1)),
                      _createElementVNode("div", _hoisted_12, [
                        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "stat-label" }, "Data Planificată", -1)),
                        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.formatDate(_ctx.selectedActivity.Data)), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "section-header" }, [
                          _createElementVNode("span", { class: "dx-icon-link section-icon" }),
                          _createElementVNode("span", null, "Context Activitate")
                        ], -1)),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _cache[13] || (_cache[13] = _createElementVNode("label", null, "Partener", -1)),
                            _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.selectedActivity.Account?.Nume || '-'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_20, [
                            _cache[14] || (_cache[14] = _createElementVNode("label", null, "Responsabil", -1)),
                            _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.selectedActivity.Owner || '-'), 1)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _cache[17] || (_cache[17] = _createElementVNode("div", { class: "section-header" }, [
                          _createElementVNode("span", { class: "dx-icon-doc section-icon" }),
                          _createElementVNode("span", null, "Descriere & Note")
                        ], -1)),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _cache[16] || (_cache[16] = _createElementVNode("label", null, "Descriere Detaliată", -1)),
                            _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.selectedActivity.Descriere || '-'), 1)
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_DxPopup, {
      visible: _ctx.addVisible,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.addVisible) = $event)),
      "close-on-outside-click": false,
      "show-close-button": false,
      "show-title": true,
      width: 700,
      height: 550,
      class: "premium-popup"
    }, {
      title: _withCtx(() => [...(_cache[18] || (_cache[18] = [
        _createElementVNode("div", { class: "popup-header" }, [
          _createElementVNode("div", { class: "popup-header-main" }, [
            _createElementVNode("span", { class: "popup-header-icon dx-icon-add" }),
            _createElementVNode("div", { class: "popup-header-texts" }, [
              _createElementVNode("div", { class: "popup-header-title" }, "Adăugare activitate"),
              _createElementVNode("div", { class: "popup-header-subtitle" }, " Completează informațiile de mai jos ")
            ])
          ]),
          _createElementVNode("div", { class: "popup-header-meta" }, [
            _createElementVNode("span", { class: "status-chip status-chip--draft" }, " Nouă ")
          ])
        ], -1)
      ]))]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_27, [
          _createVNode(_component_DxScrollView, {
            height: "100%",
            width: "100%"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_28, [
                _createVNode(_component_DxForm, {
                  "form-data": _ctx.addFormData,
                  "col-count": 2,
                  "label-location": "top"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxFormItem, {
                      "col-span": 2,
                      label: { text: 'Tip Activitate' }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxRequiredRule, { message: "Câmpul 'Tip Activitate' este obligatoriu" }),
                        _createVNode(_component_DxDropDownBox, {
                          opened: _ctx.isTipActivitateGridBoxOpened,
                          "onUpdate:opened": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isTipActivitateGridBoxOpened) = $event)),
                          "data-source": _ctx.tipActivitateSelectat,
                          value: _ctx.sTipActivitate,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.sTipActivitate) = $event)),
                          "show-clear-button": true,
                          "display-expr": "Nume",
                          "value-expr": "ID"
                        }, {
                          content: _withCtx(() => [
                            _createVNode(_component_DxDataGrid, {
                              "data-source": _ctx.dsTipActivitati,
                              columns: ['Nume'],
                              "hover-state-enabled": true,
                              height: 250,
                              onSelectionChanged: _ctx.onValueSelectedTipActivitate
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_DxSelection, { mode: "single" }),
                                _createVNode(_component_DxScrolling, { mode: "virtual" }),
                                _createVNode(_component_DxFilterRow, { visible: true }),
                                _createVNode(_component_DxSearchPanel, {
                                  visible: true,
                                  placeholder: "Cauta ..."
                                })
                              ]),
                              _: 1
                            }, 8, ["data-source", "onSelectionChanged"])
                          ]),
                          _: 1
                        }, 8, ["opened", "data-source", "value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_DxFormItem, {
                      "col-span": 2,
                      label: { text: 'Partener' }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxDropDownBox, {
                          opened: _ctx.isParteneriGridBoxOpened,
                          "onUpdate:opened": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.isParteneriGridBoxOpened) = $event)),
                          "data-source": _ctx.partenerSelectat,
                          value: _ctx.sPartener,
                          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.sPartener) = $event)),
                          "show-clear-button": true,
                          "display-expr": "Nume",
                          "value-expr": "ID"
                        }, {
                          content: _withCtx(() => [
                            _createVNode(_component_DxDataGrid, {
                              "data-source": _ctx.dsParteneri,
                              columns: ['Nume'],
                              "hover-state-enabled": true,
                              height: 250,
                              onSelectionChanged: _ctx.onValueSelectedPartener
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_DxSelection, { mode: "single" }),
                                _createVNode(_component_DxScrolling, { mode: "virtual" }),
                                _createVNode(_component_DxFilterRow, { visible: true }),
                                _createVNode(_component_DxSearchPanel, {
                                  visible: true,
                                  placeholder: "Cauta ..."
                                })
                              ]),
                              _: 1
                            }, 8, ["data-source", "onSelectionChanged"])
                          ]),
                          _: 1
                        }, 8, ["opened", "data-source", "value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_DxFormItem, {
                      "data-field": "Data",
                      "col-span": 2,
                      "editor-type": "dxDateBox",
                      "editor-options": {
                displayFormat: 'dd/MM/yyyy',
                type: 'datetime',
                dateSerializationFormat: 'yyyy-MM-ddTHH:mm:ssZ'
              }
                    }),
                    _createVNode(_component_DxFormItem, {
                      "data-field": "Descriere",
                      "col-span": 2,
                      "editor-type": "dxTextArea",
                      "editor-options": { height: 120 }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxRequiredRule, { message: "Câmpul 'Descriere' este obligatoriu" })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["form-data"])
              ])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_29, [
            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "footer-left" }, null, -1)),
            _createElementVNode("div", _hoisted_30, [
              _createVNode(_component_DxButton, {
                text: "Salvează",
                type: "success",
                width: "120",
                height: "32",
                "styling-mode": "outlined",
                disabled: _ctx.isSaving,
                onClick: _ctx.saveActivity
              }, null, 8, ["disabled", "onClick"]),
              _createVNode(_component_DxButton, {
                text: "Închide",
                type: "danger",
                width: "120",
                height: "32",
                "styling-mode": "outlined",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.addVisible = false))
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}